var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { isModelType as mstIsModelType, isArrayType as mstIsArrayType, isPrimitiveType as mstIsPrimitiveType, isIdentifierType as mstIsIdentifierType, isReferenceType as mstIsReferenceType, isUnionType as mstIsUnionType, isOptionalType as mstIsOptionalType, types } from 'mobx-state-tree';
import { getValuesOfEnum } from '../../enum/EnumHelpers';
export function isModelType(mstNodeType) {
    return mstIsModelType(mstNodeType);
}
export function isArrayType(mstNodeType) {
    return mstIsArrayType(mstNodeType);
}
export function isCoreType(mstNodeType) {
    return mstIsPrimitiveType(mstNodeType);
}
export function isIdentifierType(mstNodeType) {
    return mstIsIdentifierType(mstNodeType);
}
export function isIdentifierReferenceType(mstNodeType) {
    return mstIsReferenceType(mstNodeType);
}
export function isUnionType(mstNodeType) {
    return mstIsUnionType(mstNodeType);
}
export function isOptionalType(mstNodeType) {
    return mstIsOptionalType(mstNodeType);
}
export function addSynchronizedTimeStampIfNecessary(modelType, entity, timeStamp) {
    if (modelType.properties.synchronized) {
        entity.synchronized = timeStamp;
    }
}
export function enumerationType(enumerationName, enumeration) {
    return types.enumeration(enumerationName, Object.keys(enumeration).map(function (key) { return enumeration[key]; }));
}
export function enumerationIntValuesType(enumeration) {
    var values = getValuesOfEnum(enumeration, true);
    return types.union.apply(types, __spreadArray([], __read(values.map(function (x) { return types.literal(x); })), false));
}
//# sourceMappingURL=MstHelpers.js.map